export class IotDeviceLog {
  deviceId: string = '';
  timestamp: number = 0;
  duration: number = 0;
  connectionStatus!: ConnectionStatus;
  description: string = '';
  message!: string;
}

export enum ConnectionStatus {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  PUBLISH = 'PUBLISHED'
}

export enum ConnectionStatusOptions {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
}
